import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { faCalendarAlt as icon } from '@fortawesome/free-solid-svg-icons';
import PeriodForm from '../../../../../components/bootStrap/periodform';
import { CPButton } from '../../../../../components/bootStrap/buttons';
import { periodVarians } from '../../../../../constants/date';

function SetPeriodButton({
  disabled, onChange, content, value,
}) {
  const [opened, setOpened] = useState(false);
  const [localValue, setLocalValue] = useState(value);
  useEffect(
    () => setLocalValue(value),
    [value],
  );
  return (
    <>
      <CPButton
        icon={icon}
        onClick={() => setOpened(true)}
        content={content}
        disabled={disabled}
      />
      <Modal show={opened} onHide={() => setOpened(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            Оберіть період
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PeriodForm value={localValue} onChange={(e, v) => setLocalValue(v)} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={(e) => {
              setOpened(false);
              onChange(e, localValue);
            }}
          >
            Встановити
          </Button>
          <Button
            variant="warning"
            onClick={(e) => {
              setOpened(false);
              onChange(e, { start: null, end: null, variant: null });
            }}
          >
            Очистити
          </Button>
          <Button variant="secondary" onClick={() => setOpened(false)}>Закрити</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

SetPeriodButton.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  content: PropTypes.string,
  value: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
    variant: PropTypes.oneOf(Object.keys(periodVarians)),
  }).isRequired,
};

SetPeriodButton.defaultProps = {
  disabled: false,
  content: 'Обрати період',
};

export default SetPeriodButton;
